import axios from "axios";
import _ from "lodash";
import { Notification } from 'element-ui'

const state = {};

const mutations = {};

const actions = {
  async list(context, params) {
    try {
      const { data } = await axios.get("/promotional", {
        params
      });

      return data
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro de carregamento',
        message: _.get(
          err,
          "response.message",
          "Não foi possível carregar as promoções"
        ),
        duration: 6000,
      });
    }
  },


  async update(context, { id, promotional }) {
    try {
      const { data } = await axios.put("/promotional/" + id, promotional);

      return data;
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro ao atualizar',
        message: _.get(
          err,
          "response.message",
          "Não foi possível atualizar a promoção"
        ),
        duration: 6000,
      });
    }
  },

  async create(context, promotional) {
    try {
      const { data } = await axios.post("/promotional", promotional);

      return data;
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro ao criar',
        message: _.get(
          err,
          "response.data.error",
          "Não foi possível criar a promoção"
        ),
        duration: 6000,
      });
    }
  },

  async remove(context, promotionalId) {
    try {
      const { data } = await axios.delete("/promotional/" + promotionalId);

      return data;
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro ao excluir',
        message: _.get(
          err,
          "response.data.error",
          "Não foi possível excluir"
        ),
        duration: 6000,
      });
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
